import { Head, Link } from "@inertiajs/react"
import { ArrowLeft, ArrowRight, ChevronRight } from "lucide-react"
import { MemberLayout } from "../../components/MemberLayout"
import { LessonBody } from "./LessonBody"

export default function LessonShow({
  currentUser,
  course,
  lesson,
  questions = [],
  resources = [],
  completed,
  quiz = null,
  prevLessonId,
  nextLessonId,
}) {
  return (
    <MemberLayout currentUser={currentUser}>
      <Head title={`${lesson.title} - ${course.title} - Kingdom Factor`} />

      <div className="space-y-6 max-w-3xl mx-auto">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-1.5 text-sm text-zinc-500 flex-wrap">
          <Link
            href="/app/member/courses"
            className="hover:text-kf-red transition-colors"
          >
            Courses
          </Link>
          <ChevronRight className="h-3.5 w-3.5 shrink-0" />
          <Link
            href={`/app/member/courses/${course.id}`}
            className="hover:text-kf-red transition-colors truncate max-w-[200px]"
          >
            {course.title}
          </Link>
          <ChevronRight className="h-3.5 w-3.5 shrink-0" />
          <span className="text-zinc-900 font-medium truncate max-w-[200px]">
            {lesson.title}
          </span>
        </nav>

        <LessonBody
          course={course}
          lesson={lesson}
          questions={questions}
          resources={resources}
          completed={completed}
          quiz={quiz}
        />

        {/* Prev/Next navigation */}
        <div className="flex items-center justify-between pt-4 border-t border-zinc-200 gap-4">
          {prevLessonId ? (
            <Link
              href={`/app/member/courses/${course.id}/lessons/${prevLessonId}`}
              className="inline-flex items-center gap-1.5 text-sm font-medium text-zinc-600 hover:text-kf-red transition-colors min-h-[44px] px-3"
            >
              <ArrowLeft className="h-4 w-4" />
              Previous Lesson
            </Link>
          ) : (
            <div />
          )}
          {nextLessonId ? (
            <Link
              href={`/app/member/courses/${course.id}/lessons/${nextLessonId}`}
              className="inline-flex items-center gap-1.5 text-sm font-medium text-zinc-600 hover:text-kf-red transition-colors min-h-[44px] px-3"
            >
              Next Lesson
              <ArrowRight className="h-4 w-4" />
            </Link>
          ) : (
            <div />
          )}
        </div>
      </div>
    </MemberLayout>
  )
}
